/* eslint-disable max-lines */
import declareEvent from './declareEvent';

export const trackGuiShown = declareEvent({
  name: 'gui:shown',
  version: 3,
  getCalltimePayload: ({ guiElementName }) => ({
    gui_element: guiElementName,
    origin: 'ppf.spa'
  })
});

export const trackGuiInteracted = declareEvent({
  name: 'gui:interacted',
  version: 2,
  getCalltimePayload: ({ guiElementName, guiVariantName = null }) => ({
    gui_element: guiElementName,
    gui_variant: guiVariantName,
    interaction: 'clicked',
    origin: 'ppf.spa'
  })
});

export const trackNodeShown = declareEvent({
  name: 'lead_funnel:ppf_node:shown',
  version: 5,
  getCalltimePayload: ({ nodeNumber, flowId, flowVersion, flowLength, nodeType }) => ({
    flow_id: flowId,
    flow_version: flowVersion,
    node_position_in_flow: Number(nodeNumber),
    number_of_nodes_in_flow: flowLength,
    node_type: nodeType
  })
});

export const trackUserRedirect = declareEvent({
  name: 'lead_funnel:redirected',
  version: 6,
  requiresTrackingUuid: true,
  getCalltimePayload: ({ source, target }) => ({ source, target })
});

// Todo(post-release): call this event when a logged-in user gets redirected
export const trackLoggedInUserRedirect = declareEvent({
  name: 'lead_funnel:redirected',
  version: 5,
  requiresTrackingUuid: true,
  getCalltimePayload: ({ source, target }) => ({ source, target })
});

export const trackInvalidInput = declareEvent({
  name: 'lead_funnel:registration:failure',
  version: 5,
  requiresTrackingUuid: true,
  getCalltimePayload: ({ flowId, flowVersion, inputName, errorMessage }) => ({
    flow_id: flowId,
    flow_version: flowVersion,
    validation_input: inputName,
    validation_message: errorMessage
  })
});

export const trackSuccessfulRegistration = declareEvent({
  name: 'lead_funnel:registered',
  version: 4,
  getCalltimePayload: ({ flowId, uuid }) => ({ ppf_flow_id: flowId, uuid })
});

export const trackQuestionAsked = declareEvent({
  name: 'question:asked',
  version: 4,
  getCalltimePayload: ({ question, answerPresentationId }) => ({
    question,
    answer_presentation_id: answerPresentationId
  })
});

export const trackQuestionAnswered = declareEvent({
  name: 'question:answered',
  version: 5,
  getCalltimePayload: ({ question, answer, answerPresentationId, displayRank }) => ({
    question,
    answer,
    answer_presentation_id: answerPresentationId,
    display_rank: displayRank
  })
});

export const trackPerformance = declareEvent({
  name: 'performance:page_loaded',
  version: 1,
  getCalltimePayload: ({
    connectEnd,
    connectStart,
    domainLookupEnd,
    domainLookupStart,
    domComplete,
    domContentLoadedEventEnd,
    domContentLoadedEventStart,
    domInteractive,
    domLoading,
    fetchStart,
    loadEventEnd,
    loadEventStart,
    navigationStart,
    redirectEnd,
    redirectStart,
    responseEnd,
    responseStart,
    requestStart,
    secureConnectionStart,
    unloadEventEnd,
    unloadEventStart
  }) => ({
    connect_end: connectEnd,
    connect_start: connectStart,
    domain_lookup_end: domainLookupEnd,
    domain_lookup_start: domainLookupStart,
    dom_complete: domComplete,
    dom_content_loaded_event_end: domContentLoadedEventEnd,
    dom_content_loaded_event_start: domContentLoadedEventStart,
    dom_interactive: domInteractive,
    dom_loading: domLoading,
    fetch_start: fetchStart,
    load_event_end: loadEventEnd,
    load_event_start: loadEventStart,
    navigation_start: navigationStart,
    redirect_end: redirectEnd,
    redirect_start: redirectStart,
    response_end: responseEnd,
    response_start: responseStart,
    request_start: requestStart,
    secure_connection_start: secureConnectionStart,
    unload_event_end: unloadEventEnd,
    unload_event_start: unloadEventStart
  })
});
